import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const StripeOAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  React.useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (!code || !state) {
      console.error("Missing code or state parameter from Stripe OAuth");
      navigate("/");
      return;
    }

    try {
      const statePayload = JSON.parse(atob(state));
      const { orgPath, token } = statePayload;

      const storedToken = sessionStorage.getItem("stripe_oauth_state");

      if (storedToken !== token) {
        console.error("CSRF token mismatch in Stripe OAuth callback");
        navigate("/");
        return;
      }

      if (!orgPath) {
        console.error("Missing orgPath in Stripe OAuth state");
        navigate("/");
        return;
      }

      sessionStorage.setItem("stripe_oauth_code", code);
      navigate(`/${orgPath}/admin/stripe/updateConfiguration`);
    } catch (error) {
      console.error("Failed to parse Stripe OAuth state:", error);
      navigate("/");
    }
  }, [searchParams, navigate]);

  return <div>STRIPE CALLBACK</div>;
};
